import React, { Component } from 'react';
import classnames from 'classnames';
import { eq, includes, replace } from 'lodash';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { map, size } from 'lodash';
import { IndexLink } from 'react-router';
import * as MenuAction from '../../action/menuAction';
import * as modulePath from '../../constants/modulePath';
import MenuStore from '../../store/menuStore';

class MenuItem extends Component {

  static propTypes = {
    item: PropTypes.object,
    isChild: PropTypes.bool,
    className: PropTypes.string,
    activeClass: PropTypes.string,
    submenuSpeed: PropTypes.number
  };

  static defaultProps = {
    activeClass: 'active',
    submenuSpeed: 500
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: MenuStore.isMenuOpenByDefault(props.item)
    }
  }

  render() {
    const { className } = this.props;
    return (
      <li className={className}>
        {this._getMenuLink()}
        {this._getCollapseSign()}
        {this._getSubmenu()}
      </li>
    )
  }

  _handleClick = (e) => {
    e.preventDefault();
    const item = this.props.item;
    MenuAction.activateItem(item);
  }

  _handleNav = (e) => {
    e.preventDefault();
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  }

  _isNestedRoute(item) {
    if (item.partialRouteMatch) {
      return includes(window.location.pathname, item.partialRouteMatch);
    }

    const routeRegexp = new RegExp(`(${modulePath.getModulePathListString()})\\/(\\w+\\-?\\w+)\\/`, 'g');
    const match = routeRegexp.exec(window.location.pathname);
    if (match && match[2]) {
      return eq(replace(item.route, '/', ''), match[2]);
    }
    return false;
  }

  _hasSubMenu(item) {
    if (!item.childActions) return false;
    return !!item.childActions.find((item) => ((item.isExternal && item.route) || item.routeWithModule || item.title));
  }

  _getSubmenu() {
    const { item, activeClass } = this.props;

    if (size(item.childActions) === 0) {
      return null;
    }

    return (
      <ul className={classNames('submenu', { 'opened': this.state.isOpen })}>
        {map(item.childActions, (subitem) => (
          <MenuItem item={subitem} key={subitem.id}
                    activeClass={activeClass}/>))}
      </ul>
    );
  }

  _getCollapseSign() {
    const { item } = this.props;

    if (!this._hasSubMenu(item)) {
      return null;
    }

    const { isOpen } = this.state;

    const iconClass = {
      'fa': true,
      'fa-minus-square-o': isOpen,
      'fa-plus-square-o': !isOpen
    };

    return (
      <b className="collapse-sign" onClick={this._handleNav}>
        <em className={classnames(iconClass)}/>
      </b>
    )
  }

  _getMenuLink() {
    const { item, activeClass } = this.props;

    if (item.isExternal && item.route) {
      return (
        <a className="cursor-pointer" href={item.route} target="_blank" title={item.title}>
          <i display-if={item.icon}
            className={'fa fa-lg fa-fw ' + item.icon}/>
          <span className="menu-item-parent">{item.title}</span>
        </a>
      );
    }

    if (item.title && !item.routeWithModule) {
      return (
        <a className="cursor-pointer" title={item.title} onClick={this._handleNav}>
          <i
            display-if={item.icon}
            className={'fa fa-lg fa-fw ' + item.icon}/>
          <span
            className="menu-item-parent">{item.title}
            </span>
        </a>
      );
    }

    if (item.routeWithModule || item.icon) {
      return (
        <IndexLink
          to={item.routeWithModule}
          title={item.title}
          className={this._isNestedRoute(item) ? activeClass : ''}
          onClick={this._handleClick}
          activeClassName={activeClass}>
          <i className={'fa fa-lg fa-fw ' + item.icon}></i>
          <span className="menu-item-parent">{item.title}</span>
        </IndexLink>
      );
    }

    return null;
  }

}

export default MenuItem;
